/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOStat
 */
export interface IOStat {
    /**
     * 
     * @type {number}
     * @memberof IOStat
     */
    time: number;
    /**
     * 
     * @type {number}
     * @memberof IOStat
     */
    cRead: number;
    /**
     * 
     * @type {number}
     * @memberof IOStat
     */
    cWrite: number;
}

export function IOStatFromJSON(json: any): IOStat {
    return IOStatFromJSONTyped(json, false);
}

export function IOStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOStat {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': json['time'],
        'cRead': json['c_read'],
        'cWrite': json['c_write'],
    };
}

export function IOStatToJSON(value?: IOStat | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': value.time,
        'c_read': value.cRead,
        'c_write': value.cWrite,
    };
}


